import type { IProxy, IProxyHealthResult, IProxyListItem } from '@hit-game/shared/types';

import { http, type Paginated } from '../lib/http';

export const proxyService = {
  /** Kèm `accountUsername` — bảng proxy hiển thị TÊN tài khoản đang gán, không phải "đã gán". */
  list(params: {
    page?: number;
    limit?: number;
    search?: string;
  }): Promise<Paginated<IProxyListItem>> {
    return http.get('/proxies', { params });
  },

  checkHealth(values: string[]): Promise<IProxyHealthResult[]> {
    return http.post('/proxies/check-health', { values }, { _silent: true });
  },

  create(value: string): Promise<IProxy> {
    return http.post('/proxies', { value });
  },

  createMany(values: string[]): Promise<{ created: IProxy[]; skipped: number }> {
    return http.post('/proxies/bulk', { values });
  },

  update(id: string, value: string): Promise<IProxy> {
    return http.put(`/proxies/${id}`, { value });
  },

  remove(id: string): Promise<null> {
    return http.delete(`/proxies/${id}`);
  },
};
